export default "__VITE_PUBLIC_ASSET__7ac5626f__"